<!-- 支付结果页面 -->
<template>
  <div class="result-container text-center">
    <img class="state-img" :src="productInfo.lcAppl.inSts === 141 ? failImg : ingImg" />
    <div class="rem32 mt15">
      <span>{{ descTxt }}</span>
    </div>
    <div class="rem30 mt35 text-left" v-if="productInfo.lcAppl.inSts == 141">
        <p class="lh21">失败原因：</p>
        <p class="lh21">{{ productInfo.fstPayRecord.msg }}</p>
    </div>
    <div class="result-btn">
      <van-button round block color="#4D7BFE" v-if="productInfo.lcAppl.inSts == 141" class="btn" @click="toPay">
        <span class="rem34">重新支付</span>
      </van-button>
      <van-button round block color="#4D7BFE" class="btn" @click="toIndex">
        <span class="rem34">返回首页</span>
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import { Button } from 'vant'
import { dealerDetailApi } from '@/apis/kdb'
import wx from 'weixin-js-sdk';


Vue.use(Button)
export default {
  data() {
    return {
      ingImg: require('@/assets/images/kdb/pay-ing.png'),
      failImg: require('@/assets/images/kdb/pay-fail.png'),
      productInfo: {
        lcAppl: {
          inSts: 0
        }
      },
      descTxt: ''
    }
  },
  async created() {
    this.dealerDetailFun()
  },
  computed: {
    ...mapState({
      loanNo: (state) => state.borrow.loanNo,
      faceToken: (state) => state.borrow.faceToken,
      productCode: (state) => state.common.productCode,
      applySeq: (state) => state.borrow.applySeq,
    }),
  },
  methods: {
    async dealerDetailFun(){
        try {
            let id = this.$store.state.common.id || localStorage.getItem('id')
            let res = await dealerDetailApi({id}) 
            if (res && res.code == 200) {
                this.productInfo = res.data
                this.descTxt = [140, 141].includes(this.productInfo.lcAppl.inSts) ? this.productInfo.fstPayRecord.status == '150' ? '支付中' : '支付失败' : '支付成功'
                if(this.productInfo.lcAppl.inSts === 150){
                  // 放款审核页面
                  this.$router.push({
                    path: '/approvel-pass-result'
                  })
                }else if(this.productInfo.lcAppl.inSts === 200) {
                  // 放款成功
                  this.$router.push({
                      path: '/approvel-pass-result',
                  })
                }else if(this.productInfo.lcAppl.inSts === 300){
                  // 放款失败 inSts === 300
                  this.$router.push({
                      path: '/approvel-refuse-result',
                  })
                }
            } else {
                this.$common.toast(res.msg)
            }
        } catch (error) {}
    },
    toIndex() {
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        // 返回卡电宝小程序
        wx.miniProgram.reLaunch({
          url: `/pages/new/main/index?appId=${process.env.VUE_APP_KDB_APPID}`
        })
      } else {
        console.log('请在微信环境中打开');
        this.$router.push({ path: this.$store.state.common.defaultIndex })
      }
    },
    toPay(){
      this.$router.push({
        path: '/downPayment'
      })
    }
  },
}
</script>

<style lang="less" scoped>
.result-container {
  padding: 0 0.42rem /* 21/50 */;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  .state-img {
    margin-top: 1rem;
    width: 3.42rem;
    height: 3.32rem;
  }
  .result-btn {
    position: absolute;
    margin-top: 0.82rem /* 41/50 */;
    bottom: 2.3rem;
    width: calc(100% - 0.84rem);
  }
  .btn {
    margin-top: 0.48rem /* 24/50 */;
  }
}
</style>
